import { useStaticQuery, graphql } from "gatsby";
import { keysToCamel } from "@utils";

const query = graphql`
  query AllCountriesQuery {
    allCountry {
      nodes {
        code
        id
        name
        requires_administrative_area
        administrative_areas {
          id
          title
        }
      }
    }
  }
`;

const dataResolver = ({ allCountry }) => {
  const { nodes } = allCountry || {};
  const countries = nodes.map(s =>
    keysToCamel({ ...s, id: s.code, title: s.name })
  );
  return countries;
};

const useContactPageData = () => {
  const response = useStaticQuery(query);
  return dataResolver(response);
};

export default useContactPageData;
